<main class="selection-page">
  <header class="selection-header">
    <img
      src="/images/DSDN_Images/desimonelogoblack.png"
      alt="DeSimone"
      class="brand-logo"
    >

    <div class="account-actions">
      <span *ngIf="user?.email || user?.userName" class="signed-in-user">
        {{ user?.email || user?.userName }}
      </span>
      <button type="button" class="sign-out-button" (click)="logout()">Sign out</button>
    </div>
  </header>

  <section class="selection-content" aria-labelledby="selection-title">
    <div class="heading-block">
      <p class="eyebrow">Customer access</p>
      <h1 id="selection-title">Choose a customer</h1>
      <p>Select a customer to open its read-only workspace.</p>
    </div>

    <div *ngIf="error" class="alert" role="alert">
      <span>{{ error }}</span>
      <button *ngIf="!selectingCustomerId" type="button" (click)="loadCustomers()">Try again</button>
    </div>

    <div *ngIf="loading" class="loading-state" aria-live="polite">
      <div class="loading-spinner"></div>
      <span>Loading customers...</span>
    </div>

    <div *ngIf="!loading && !error && customers.length === 0" class="empty-state">
      <h2>No customers available</h2>
      <p>The customer catalog is currently empty.</p>
    </div>

    <div *ngIf="!loading && customers.length > 0" class="customer-grid">
      <button
        *ngFor="let customer of customers; trackBy: trackCustomer"
        type="button"
        class="customer-card"
        [disabled]="selectingCustomerId !== null"
        (click)="selectCustomer(customer)"
      >
        <span class="customer-logo">
          <img *ngIf="customer.logoUrl" [src]="customer.logoUrl" alt="">
          <span *ngIf="!customer.logoUrl" aria-hidden="true">
            {{ customer.name.charAt(0).toUpperCase() }}
          </span>
        </span>

        <span class="customer-details">
          <strong>{{ customer.name }}</strong>
          <small>Open workspace</small>
        </span>

        <span *ngIf="selectingCustomerId !== customer.id" class="arrow" aria-hidden="true">&rarr;</span>
        <span *ngIf="selectingCustomerId === customer.id" class="card-spinner" aria-hidden="true"></span>
      </button>
    </div>
  </section>
</main>
